import {http, onSuccess, onFail} from '../player/http';

export const eventModuleQuestionsUpdate = (eventId, data) => {
    return http.post(`/api/admin/event/${eventId}/module/question`, data)
        .then(onSuccess, onFail);
};
